import { PLAYBOOK_TYPES } from '../types/picks';

// Descriptions for Odikai playbooks
export const PLAYBOOK_DESCRIPTIONS = {
  [PLAYBOOK_TYPES.BASELINE]: "Straight picks, no parlays, even bets. This is a single strategy.",
  [PLAYBOOK_TYPES.FLURRY]: "Even bets on all possible three-leg parlays, with each fighter appearing no more than twice. This only includes fighters with at least three fights. This is a single strategy.",
  [PLAYBOOK_TYPES.STANDARD]: "This playbook is focused on maximizing returns by taking on more risk. You might get some big hits, but you can lose more of your budget when things go wrong.",
  [PLAYBOOK_TYPES.FLEX]: "This playbook has fewer restrictions when picking strategies than the Standard or Growth playbooks. It's our best performing playbook, and you'll probably make money, but the picks may seem strange.",
  [PLAYBOOK_TYPES.GROWTH]: "This playbook is focused on minimizing risk. You probably won't see huge returns, but you won't see huge losses either.",
  [PLAYBOOK_TYPES.DRAKE]: "This playbook is trained on Drake's previous UFC picks and recreates his pick tendencies. This is a single strategy.",
  [PLAYBOOK_TYPES.SHARKS]: "This playbook is trained on top performing cappers across the internet.",
  [PLAYBOOK_TYPES.VALUE]: "Bets on the fighters our model gives a better chance than the odds do, by at least two points: favourites and underdogs alike, even stakes. This is a single strategy.",
  [PLAYBOOK_TYPES.EQUAL]: "Every strategy that made money in our latest backtest, each given the same weight. No optimizing, so no single strategy can dominate it."
};

// Mock data for playbooks
export const mockPlaybooks = {
  [PLAYBOOK_TYPES.BASELINE]: {
    id: PLAYBOOK_TYPES.BASELINE,
    name: 'Baseline',
    description: PLAYBOOK_DESCRIPTIONS[PLAYBOOK_TYPES.BASELINE],
    strategies: 1,
    last_updated: new Date().toISOString(),
    picks: [
      {
        pick_name: "Josias Musasa",
        opponent_name: "Carlos Vera",
        budget_amount: 0.0361,
        american_odds: "-666",
        decimal_odds: 1.15,
        supporting_strategies: 4,
        type: 'moneyline'
      },
      {
        pick_name: "Marvin Vettori",
        opponent_name: "Roman Dolidze",
        budget_amount: 0.035,
        american_odds: "-166",
        decimal_odds: 1.6,
        supporting_strategies: 3,
        type: 'moneyline'
      }
    ]
  },
  [PLAYBOOK_TYPES.FLURRY]: {
    id: PLAYBOOK_TYPES.FLURRY,
    name: 'Flurry',
    description: PLAYBOOK_DESCRIPTIONS[PLAYBOOK_TYPES.FLURRY],
    strategies: 6,
    last_updated: new Date().toISOString(),
    picks: [
      {
        pick_name: "Andre Lima, Da'Mon Blackshear, Diyar Nurgozhay & Kevin Vallejos",
        opponent_name: "Daniel Barez, Cody Gibson, Brendson Ribeiro & SeungWoo Choi",
        budget_amount: 0.0305,
        american_odds: "+137",
        decimal_odds: 2.38,
        supporting_strategies: 1,
        type: 'parlay'
      }
    ]
  },
  [PLAYBOOK_TYPES.STANDARD]: {
    id: PLAYBOOK_TYPES.STANDARD,
    name: 'Standard',
    description: PLAYBOOK_DESCRIPTIONS[PLAYBOOK_TYPES.STANDARD],
    strategies: 4,
    last_updated: new Date().toISOString(),
    picks: [
      {
        pick_name: "Waldo Cortes-Acosta",
        opponent_name: "Ryan Spann",
        budget_amount: 0.0305,
        american_odds: "-166",
        decimal_odds: 1.6,
        supporting_strategies: 4,
        type: 'moneyline'
      }
    ]
  },
  [PLAYBOOK_TYPES.FLEX]: {
    id: PLAYBOOK_TYPES.FLEX,
    name: 'Flex',
    description: PLAYBOOK_DESCRIPTIONS[PLAYBOOK_TYPES.FLEX],
    strategies: 8,
    last_updated: new Date().toISOString(),
    picks: [
      {
        pick_name: "Marvin Vettori",
        opponent_name: "Roman Dolidze",
        budget_amount: 0.04,
        american_odds: "-166",
        decimal_odds: 1.6,
        supporting_strategies: 6,
        type: 'moneyline'
      }
    ]
  },
  [PLAYBOOK_TYPES.GROWTH]: {
    id: PLAYBOOK_TYPES.GROWTH,
    name: 'Growth',
    description: PLAYBOOK_DESCRIPTIONS[PLAYBOOK_TYPES.GROWTH],
    strategies: 3,
    last_updated: new Date().toISOString(),
    picks: [
      {
        pick_name: "Josias Musasa",
        opponent_name: "Carlos Vera",
        budget_amount: 0.033,
        american_odds: "-666",
        decimal_odds: 1.15,
        supporting_strategies: 2,
        type: 'moneyline'
      }
    ]
  }
}; 